/* =============================================================
   ECOBOS PRODUCT CONFIGURATOR - V11
   Generieke options-engine
   ============================================================= */

(function() {

  'use strict';


  function initEcobosConfigurator(root) {

    if (!root) return;


    if (
      root.dataset.configuratorInitialized ===
      'true'
    ) {
      return;
    }

    const productConfiguratorElement =
      root.querySelector(
        '[data-product-configurator]'
      );

    let config = null;

    let productConfigurator = null;

    if (productConfiguratorElement) {

      try {

        const parsedProductConfigurator =
          JSON.parse(
            productConfiguratorElement.textContent
          );

        if (
          parsedProductConfigurator &&
          typeof parsedProductConfigurator === 'object'
        ) {

          productConfigurator =
            parsedProductConfigurator;

        }

      }

      catch(error) {

        console.warn(
          'ECOBOS configurator: nieuwe productconfigurator kon niet worden gelezen.',
          error
        );

      }

    }

    root.dataset.configuratorInitialized =
      'true';


    const urlParams =
      new URLSearchParams(
        window.location.search
      );


    const editingCartItemId =
      urlParams.get(
        'ecobos_edit'
      );


    const cartReturnUrl =
      urlParams.get(
        'ecobos_return'
      );

    function buildConfigFromProductConfigurator(
      productConfigurator
    ) {

      if (!productConfigurator) {
        return null;
      }

      const quantities =
        Array.isArray(
          productConfigurator.quantities
        )
          ? productConfigurator.quantities.map(Number)
          : [];

      const positions = [];
      const methods = {};

      (
        productConfigurator.personalisationPositions || []
      ).forEach(
        function(position) {

          const methodIds = [];

          (
            position.methods || []
          ).forEach(
            function(method) {

              if (!method.code) {
                return;
              }

              methodIds.push(
                method.code
              );

              methods[
                method.code
              ] = {
                label:
                  method.name,

                minimumQuantity:
                  Number(
                    method.minimumQuantity || 0
                  ),

                priceSeries:
                  method.priceSeries || null
              };

            }
          );

          positions.push({
            id:
              position.code,

            label:
              position.name,

            methods:
              methodIds
          });

        }
      );

      const options = [];

      if (positions.length) {

        const personalisationOption = {
          id:
            'personalisation',

          type:
            'personalisation',

          label:
            'Personalisatie',

          positions:
            positions,

          methods:
            methods
        };


        if (
          productConfigurator.showNoPersonalisation
        ) {

          personalisationOption.noPersonalisation = {
            enabled:
              true,

            label:
              'Geen personalisatie'
          };

        }


        options.push(
          personalisationOption
        );

      } 

      /*
      * AANTALVERDELINGEN
      */

      (
        productConfigurator.quantityDistributions || []
      ).forEach(
        function(distribution) {

          if (
            !distribution.code ||
            !Array.isArray(
              distribution.dimensions
            ) ||
            !distribution.dimensions.length
          ) {
            return;
          }


          options.unshift({
            id:
              distribution.code,

            type:
              'quantity_distribution',

            label:
              distribution.name,

            required:
              Boolean(
                distribution.required
              ),

            dimensions:
              distribution.dimensions
          });

        }
      );
      
      (productConfigurator.choiceOptions || []).forEach(
        function(choiceOption) {

          if (!choiceOption.code) {
            return;
          }

          const choices = [];

          (
            choiceOption.choices || []
          ).forEach(
            function(choice) {

              if (!choice.code) {
                return;
              }

              choices.push({
                id:
                  choice.code,

                label:
                  choice.name,

                minimumQuantity:
                  Number(
                    choice.minimumQuantity || 0
                  ),

                priceSeries:
                  choice.priceSeries || null
              });

            }
          );


          if (!choices.length) {
            return;
          }


          options.push({
            id:
              choiceOption.code,

            type:
              'single_choice',

            label:
              choiceOption.name,

            required:
              Boolean(
                choiceOption.required
              ),

            choices:
              choices
          });

        }
      );

      return {
        basePrice: {
          priceSeries:
            productConfigurator.basePrice || null
        },

        quantity: {
          presets:
            quantities,

          minimum:
            quantities.length
              ? Math.min(...quantities)
              : 1
        },

        options:
          options
      };

    }

    const metaobjectConfig =
      buildConfigFromProductConfigurator(
        productConfigurator
      );

    console.log(
      'ECOBOS nieuwe metaobject-config:',
      metaobjectConfig
    );

    if (metaobjectConfig) {

      config =
        metaobjectConfig;

    }

    /* =========================================================
       STATE
       ========================================================= */

    const state = {

      quantity:
        config.quantity.presets[0],

      quantityConfirmed:
        false,

      options:
        {}

    };


    config.options.forEach(
      function(option) {

        if (
          option.type ===
          'personalisation'
        ) {

          state.options[
            option.id
          ] = {

            noPersonalisation:
              false,

            positions:
              {},

            activePosition:
              null,

            addingExtraPosition:
              false,

            editingPosition:
              null

          };


          option.positions.forEach(
            function(position) {

              state.options[
                option.id
              ].positions[
                position.id
              ] = {

                enabled:
                  false,

                method:
                  null

              };

            }
          );

        }


        else if (
          option.type ===
          'single_choice'
        ) {

          state.options[
            option.id
          ] = {

            choice:
              null

          };

        }

        else if (
          option.type ===
          'quantity_distribution'
        ) {

          state.options[option.id] = {

            /*
            * Geselecteerde waarden
            * bv. basilicum / zonnebloem
            */
            selectedValues: {},


            /*
            * Effectieve aantallenverdeling
            *
            * bv.
            * {
            *   basilicum: 700,
            *   zonnebloem: 300
            * }
            */
            distribution: {},


            /*
            * De situatie waarvoor bovenstaande
            * verdeling werd gemaakt.
            *
            * Zo kunnen we herkennen wanneer
            * totaal of selectie gewijzigd is.
            */
            distributionContext: {
              quantity: null,
              selectionKey: null
            },


            /*
            * Wordt later true zodra de klant
            * zelf een verdeling aanpast.
            */
            manuallyAdjusted: false,
            distributionConfirmed: false,
            editingValue: null

          };

        }

      }
    );


    /* =========================================================
       DOM
       ========================================================= */

    const optionsStepsContainer =
      root.querySelector(
        '[data-options-steps]'
      );


    const priceTable =
      root.querySelector(
        '[data-price-table]'
      );


    const customQuantityInput =
      root.querySelector(
        '[data-custom-quantity]'
      );


    const summaryOptions =
      root.querySelector(
        '[data-summary-options]'
      );


    const summaryQuantity =
      root.querySelector(
        '[data-summary-quantity]'
      );

    const quantityStepSummary =
      root.querySelector(
        '[data-quantity-step-summary]'
      );

    const distributionStepSummary =
      root.querySelector(
        '[data-distribution-step-summary]'
      );

    const summaryUnitPrice =
      root.querySelector(
        '[data-summary-unit-price]'
      );


    const summarySetup =
      root.querySelector(
        '[data-summary-setup]'
      );


    const summaryTotal =
      root.querySelector(
        '[data-summary-total]'
      );


    const addToCartButton =
      root.querySelector(
        '[data-add-to-cart]'
      );


    const addToCartMessage =
      root.querySelector(
        '[data-add-to-cart-message]'
      );


    const variantId =
      parseInt(
        root.dataset.variantId,
        10
      );


    const productTitle =
      root.dataset.productTitle || '';


    const productUrl =
      root.dataset.productUrl || '';


    const productImage =
      root.dataset.productImage || '';


    const ECOBOS_CART_KEY =
      'ecobos_cart_v1';


    /* =========================================================
       HELPERS
       ========================================================= */

    function roundMoney(value) {

      return (
        Math.round(
          (
            Number(value) +
            Number.EPSILON
          ) * 100
        ) / 100
      );

    }


    function money(value) {

      return new Intl.NumberFormat(
        'nl-BE',
        {
          style:
            'currency',

          currency:
            'EUR',

          minimumFractionDigits:
            2,

          maximumFractionDigits:
            2
        }
      ).format(
        roundMoney(value)
      );

    }


    function getEcobosCart() {

      try {

        const stored =
          localStorage.getItem(
            ECOBOS_CART_KEY
          );


        if (!stored) {

          return {
            version: 1,
            items: []
          };

        }


        const cart =
          JSON.parse(stored);


        if (
          !cart ||
          !Array.isArray(cart.items)
        ) {

          return {
            version: 1,
            items: []
          };

        }


        return cart;

      }

      catch(error) {

        console.error(
          'ECOBOS cart kon niet worden gelezen:',
          error
        );


        return {
          version: 1,
          items: []
        };

      }

    }


    function saveEcobosCart(cart) {

      localStorage.setItem(
        ECOBOS_CART_KEY,
        JSON.stringify(cart)
      );


      window.dispatchEvent(
        new CustomEvent(
          'ecobos:cart:updated',
          {
            detail: cart
          }
        )
      );

    }


    function createCartItemId() {

      if (
        window.crypto &&
        typeof window.crypto.randomUUID ===
          'function'
      ) {

        return window.crypto.randomUUID();

      }


      return (
        'ecobos-' +
        Date.now() +
        '-' +
        Math.random()
          .toString(36)
          .slice(2)
      );

    }


    function buildCartConfiguration() {

      const result = [];


      config.options.forEach(
        function(option) {

          const optionState =
            state.options[option.id];


          if (!optionState) {
            return;
          }


          if (
            option.type ===
            'personalisation'
          ) {

            if (
              optionState.noPersonalisation
            ) {

              result.push({
                optionId:
                  option.id,

                optionLabel:
                  option.label,

                type:
                  option.type,

                noPersonalisation:
                  true,

                positions:
                  []
              });


              return;

            }


            const positions =
              [];


            getCompletedPositions(
              option
            ).forEach(
              function(position) {

                const positionState =
                  optionState.positions[
                    position.id
                  ];


                const method =
                  option.methods[
                    positionState.method
                  ];


                if (!method) {
                  return;
                }


                positions.push({

                  positionId:
                    position.id,

                  positionLabel:
                    position.label,

                  methodId:
                    positionState.method,

                  methodLabel:
                    method.label

                });

              }
            );


            result.push({

              optionId:
                option.id,

              optionLabel:
                option.label,

              type:
                option.type,

              noPersonalisation:
                false,

              positions:
                positions

            });

          }


          else if (
            option.type ===
            'single_choice'
          ) {

            if (
              !optionState.choice
            ) {
              return;
            }


            const choice =
              getChoice(
                option,
                optionState.choice
              );


            if (!choice) {
              return;
            }


            result.push({

              optionId:
                option.id,

              optionLabel:
                option.label,

              type:
                option.type,

              choiceId:
                choice.id,

              choiceLabel:
                choice.label

            });

          }

          else if (
            option.type ===
            'quantity_distribution'
          ) {

            /*
            * Zorg dat de effectieve verdeling
            * altijd actueel is.
            */

            ensureQuantityDistribution(
              option
            );


            const values =
              [];


            (
              option.dimensions || []
            ).forEach(
              function(dimension) {

                (
                  dimension.values || []
                ).forEach(
                  function(value) {

                    if (
                      !optionState.selectedValues[
                        value.code
                      ]
                    ) {
                      return;
                    }


                    values.push({

                      dimensionId:
                        dimension.code,

                      dimensionLabel:
                        dimension.name,

                      valueId:
                        value.code,

                      valueLabel:
                        value.name,

                      quantity:
                        Number(
                          optionState.distribution[
                            value.code
                          ] || 0
                        )

                    });

                  }
                );

              }
            );


            /*
            * Bij één gekozen waarde krijgt
            * die automatisch het volledige
            * bestelde aantal.
            */

            if (
              values.length === 1
            ) {

              values[0].quantity =
                state.quantity;

            }


            result.push({

              optionId:
                option.id,

              optionLabel:
                option.label,

              type:
                option.type,

              values:
                values

            });

          }

        }
      );


      return result;

    }


    function getOption(
      optionId
    ) {

      return config.options.find(
        function(option) {

          return (
            option.id ===
            optionId
          );

        }
      );

    }


    function getChoice(
      option,
      choiceId
    ) {

      if (
        !option ||
        !option.choices
      ) {

        return null;

      }


      return option.choices.find(
        function(choice) {

          return (
            choice.id ===
            choiceId
          );

        }
      );

    }


    function getPosition(
      option,
      positionId
    ) {

      if (
        !option ||
        !option.positions
      ) {

        return null;

      }


      return option.positions.find(
        function(position) {

          return (
            position.id ===
            positionId
          );

        }
      );

    }

    /*
     * Ondersteunt:
     *
     * price: 0.25
     *
     * of:
     *
     * tiers: [...]
     *
     * of helemaal geen prijs.
     */

    function getCentralSeriesPrice(
      series,
      quantity
    ) {

      if (
        !series ||
        !Array.isArray(series.quantities) ||
        !series.quantities.length ||
        !Array.isArray(series.prices) ||
        !series.prices.length
      ) {

        return null;

      }


      let selectedIndex =
        -1;


      series.quantities.forEach(
        function(from, index) {

          if (
            quantity >=
            Number(from)
          ) {

            selectedIndex =
              index;

          }

        }
      );


      if (
        selectedIndex === -1
      ) {

        return null;

      }


      /*
      * Laatste bekende prijs loopt door.
      *
      * Voorbeeld:
      * aantallen:
      * 100 / 250 / 500 / 1000 / 2500
      *
      * prijzen:
      * 0.30 / 0.25 / 0.20
      *
      * => 1000 en 2500 gebruiken 0.20
      */

      let selectedPrice =
        null;


      for (
        let index = 0;
        index <= selectedIndex;
        index += 1
      ) {

        if (
          index < series.prices.length &&
          series.prices[index] !== null &&
          series.prices[index] !== '' &&
          !Number.isNaN(
            Number(
              series.prices[index]
            )
          )
        ) {

          selectedPrice =
            Number(
              series.prices[index]
            );

        }

      }


      return selectedPrice;

    }

    function getResolvedItemPrice(
      item,
      quantity
    ) {

      /*
      * Nieuwe metaobject-prijsreeks.
      */

      if (
        item &&
        item.priceSeries
      ) {

        const metaobjectPrice =
          getCentralSeriesPrice(
            item.priceSeries,
            quantity
          );

        if (
          metaobjectPrice !== null
        ) {

          return metaobjectPrice;

        }

      }

      return 0;

    }

    function getBasePrice(
      quantity
    ) {

      if (
        config.basePrice &&
        config.basePrice.priceSeries
      ) {

        const metaobjectPrice =
          getCentralSeriesPrice(
            config.basePrice.priceSeries,
            quantity
          );

        if (
          metaobjectPrice !== null
        ) {

          return metaobjectPrice;

        }

      }

      return 0;

    }


    function getCompletedPositions(
      option
    ) {

      const optionState =
        state.options[
          option.id
        ];


      return option.positions.filter(
        function(position) {

          const selected =
            optionState.positions[
              position.id
            ];


          return (
            selected.enabled &&
            selected.method
          );

        }
      );

    }


    function getAvailablePositions(
      option
    ) {

      const optionState =
        state.options[
          option.id
        ];


      return option.positions.filter(
        function(position) {

          const selected =
            optionState.positions[
              position.id
            ];


          return !(
            selected.enabled &&
            selected.method
          );

        }
      );

    }


    /* =========================================================
       PRIJSBEREKENING
       ========================================================= */

    function calculatePrice(
  quantity
) {

  let unitPrice =
    getBasePrice(
      quantity
    );


  config.options.forEach(
    function(option) {

      const optionState =
        state.options[
          option.id
        ];


      /*
       * PERSONALISATIE
       */

      if (
        option.type ===
        'personalisation'
      ) {

        if (
          optionState.noPersonalisation
        ) {
          return;
        }


        getCompletedPositions(
          option
        ).forEach(
          function(position) {

            const positionState =
              optionState.positions[
                position.id
              ];


            const method =
              option.methods[
                positionState.method
              ];


            unitPrice +=
              getResolvedItemPrice(
                method,
                quantity,
                positionState.method
              );

          }
        );

      }


      /*
       * SINGLE CHOICE
       */

      else if (
        option.type ===
        'single_choice'
      ) {

        if (
          !optionState.choice
        ) {
          return;
        }


        const choice =
          getChoice(
            option,
            optionState.choice
          );


        unitPrice +=
          getResolvedItemPrice(
            choice,
            quantity,
            choice.id
          );

      }

    }
  );


  unitPrice =
    roundMoney(
      unitPrice
    );


  const productsTotal =
    roundMoney(
      unitPrice *
      quantity
    );


  return {

    unitPrice,

    productsTotal,

    setupFees:
      0,

    total:
      productsTotal

  };

}


    /* =========================================================
       TOEVOEGEN / WIJZIGEN WINKELMANDJE
       ========================================================= */

    function addToCart() {

      if (
        !variantId ||
        !state.quantity
      ) {

        return;

      }

      /*
      * Aantalverdelingen valideren
      * voordat het product naar het
      * winkelmandje mag.
      */

      for (
        const option of
        config.options
      ) {

        if (
          option.type !==
          'quantity_distribution'
        ) {
          continue;
        }


        ensureQuantityDistribution(
          option
        );


        const validation =
          getQuantityDistributionValidation(
            option
          );


        /*
        * Bij twee of meer gekozen waarden
        * moet de verdeling eerst bevestigd zijn.
        */

        if (
          validation.selectedCount > 1 &&
          !state.options[
            option.id
          ].distributionConfirmed
        ) {

          if (
            addToCartMessage
          ) {

            addToCartMessage.hidden =
              false;

            addToCartMessage.textContent =
              'Bevestig eerst de verdeling.';

          }


          openOnlyStep(
            'distribution'
          );


          return;

        }


        if (
          !validation.valid
        ) {

          if (
            addToCartMessage
          ) {

            addToCartMessage.hidden =
              false;


            if (
              validation.selectedCount === 0
            ) {

              addToCartMessage.textContent =
                'Kies minstens één optie voor ' +
                option.label +
                '.';

            }

            else {

              addToCartMessage.textContent =
                'De verdeling moet minstens ' +
                validation.minimumQuantity +
                ' stuks bevatten.';

            }

          }


          /*
          * Open de juiste stap.
          */

          if (
            validation.selectedCount === 0
          ) {

            openOnlyStep(
              'option:' +
              option.id
            );

          }

          else {

            openOnlyStep(
              'distribution'
            );

          }


          return;

        }

      }

      const pricing =
        calculatePrice(
          state.quantity
        );


      const cartItem = {

        id:
          editingCartItemId ||
          createCartItemId(),

        variantId:
          variantId,

        productName:
          productTitle ||
          document.title,

        productUrl:
          productUrl ||
          window.location.pathname,

        productImage:
          productImage,

        quantity:
          state.quantity,

        unitPrice:
          pricing.unitPrice,

        productsTotal:
          pricing.productsTotal,

        setupFees:
          pricing.setupFees,

        total:
          pricing.total,

        configuration:
          buildCartConfiguration(),

        state: {

          options:
            JSON.parse(
              JSON.stringify(
                state.options
              )
            )

        },

        pricingConfig:
          JSON.parse(
            JSON.stringify(
              config
            )
          )

      };


      if (
        addToCartButton
      ) {

        addToCartButton.disabled =
          true;


        addToCartButton.textContent =
          editingCartItemId
            ? 'Opslaan...'
            : 'Toevoegen...';

      }


      if (
        addToCartMessage
      ) {

        addToCartMessage.hidden =
          true;

      }


      try {

        const cart =
          getEcobosCart();


        /*
         * BESTAAND ITEM WIJZIGEN
         */

        if (
          editingCartItemId
        ) {

          const existingIndex =
            cart.items.findIndex(
              function(item) {

                return (
                  item.id ===
                  editingCartItemId
                );

              }
            );


          if (
            existingIndex !== -1
          ) {

            cartItem.addedAt =
              cart.items[
                existingIndex
              ].addedAt ||
              new Date().toISOString();


            cartItem.updatedAt =
              new Date().toISOString();


            cart.items[
              existingIndex
            ] =
              cartItem;

          }


          /*
           * Item bestaat niet meer.
           * Dan opnieuw toevoegen.
           */

          else {

            cartItem.addedAt =
              new Date().toISOString();


            cartItem.updatedAt =
              new Date().toISOString();


            cart.items.push(
              cartItem
            );

          }

        }


        /*
         * NIEUW ITEM
         */

        else {

          cartItem.addedAt =
            new Date().toISOString();


          cart.items.push(
            cartItem
          );

        }


        saveEcobosCart(
          cart
        );


        if (
          addToCartMessage
        ) {

          addToCartMessage.hidden =
            false;

        }


        /*
         * WIJZIGING OPGESLAGEN
         */

        if (
          editingCartItemId
        ) {

          if (
            addToCartMessage
          ) {

            addToCartMessage.textContent =
              'Wijzigingen opgeslagen.';

          }


          if (
            addToCartButton
          ) {

            addToCartButton.textContent =
              'Opgeslagen ✓';

          }


          window.setTimeout(
            function() {

              /*
               * Alleen lokale URL's toelaten.
               */

              if (
                cartReturnUrl &&
                cartReturnUrl.charAt(0) === '/'
              ) {

                window.location.href =
                  cartReturnUrl;

              }

              else {

                window.history.back();

              }

            },
            500
          );

        }


        /*
         * NORMAAL TOEGEVOEGD
         */

        else {

          if (
            addToCartMessage
          ) {

            addToCartMessage.textContent =
              'Toegevoegd aan je winkelmandje.';

          }


          if (
            addToCartButton
          ) {

            addToCartButton.textContent =
              'Toegevoegd ✓';

          }


          window.setTimeout(
            function() {

              if (
                addToCartButton
              ) {

                addToCartButton.disabled =
                  false;


                addToCartButton.textContent =
                  'In winkelmandje';

              }

            },
            1500
          );

        }

      }


      catch(error) {

        console.error(
          'ECOBOS cart:',
          error
        );


        if (
          addToCartMessage
        ) {

          addToCartMessage.hidden =
            false;


          addToCartMessage.textContent =
            'Er ging iets mis bij het bewaren van je winkelmandje.';

        }


        if (
          addToCartButton
        ) {

          addToCartButton.disabled =
            false;


          addToCartButton.textContent =
            editingCartItemId
              ? 'Wijzigingen opslaan'
              : 'In winkelmandje';

        }

      }

    }


    /* =========================================================
       STAPPEN OPBOUWEN
       ========================================================= */

    function renderOptionSteps() {

      optionsStepsContainer.innerHTML =
        '';


      config.options.forEach(
        function(option, index) {

          const step =
            document.createElement(
              'div'
            );


          step.className =
            'ecobos-step';


          if (
            index === 0
          ) {

            step.classList.add(
              'is-open'
            );

          }


          step.setAttribute(
            'data-step',
            ''
          );


          step.dataset.stepId =
            'option:' +
            option.id;


          step.dataset.optionId =
            option.id;


          step.innerHTML =

            '<div class="ecobos-step__header">' +

              '<span class="ecobos-step__number">' +
                (index + 1) +
              '</span>' +

              '<span class="ecobos-step__heading">' +

                '<strong>' +
                  option.label +
                '</strong>' +

                '<span data-step-summary="' +
                  option.id +
                '">' +
                  'Maak je keuze' +
                '</span>' +

              '</span>' +

            '</div>' +

            '<div class="ecobos-step__body">' +

              '<div class="ecobos-step__content">' +

                (
                  option.intro
                    ?
                      '<p class="ecobos-step__intro">' +
                        option.intro +
                      '</p>'
                    :
                      ''
                ) +

                '<div data-option-content="' +
                  option.id +
                '"></div>' +

              '</div>' +

            '</div>';


          optionsStepsContainer.appendChild(
            step
          );

        }
      );


      const quantityStepNumber =
        root.querySelector(
          '[data-quantity-step-number]'
        );


      if (
        quantityStepNumber
      ) {

        quantityStepNumber.textContent =
          config.options.length +
          1;

      }

      const distributionStepNumber =
        root.querySelector(
          '[data-distribution-step-number]'
        );


      if (
        distributionStepNumber
      ) {

        distributionStepNumber.textContent =
          config.options.length +
          2;

      }

    }


    /* =========================================================
       ACCORDION
       ========================================================= */

    function getStep(
      stepId
    ) {

      return root.querySelector(
        '[data-step-id="' +
        stepId +
        '"]'
      );

    }


    function setStepOpen(
      step,
      open
    ) {

      if (!step) {
        return;
      }


      step.classList.toggle(
        'is-open',
        open
      );

      updateStepSummaries();

    }


    function openOnlyStep(
      stepId
    ) {

      root
        .querySelectorAll(
          '[data-step]'
        )
        .forEach(
          function(step) {

            setStepOpen(
              step,
              step.dataset.stepId ===
              stepId
            );

          }
        );

    }


    function openNextStep(
      optionId
    ) {

      /*
      * Zoek eerst naar de eerste
      * nog niet voltooide optiestap.
      */

      for (
        const option of
        config.options
      ) {

        const step =
          getStep(
            'option:' +
            option.id
          );


        if (
          step &&
          !step.classList.contains(
            'is-complete'
          )
        ) {

          openOnlyStep(
            'option:' +
            option.id
          );


          return;

        }

      }


      /*
      * Daarna het aantal.
      */

      if (
        !state.quantityConfirmed
      ) {

        openOnlyStep(
          'quantity'
        );


        return;

      }


      /*
      * Daarna eventueel de verdeling.
      */

      const distributionOption =
        config.options.find(
          function(option) {

            return (
              option.type ===
              'quantity_distribution'
            );

          }
        );


      if (
        distributionOption
      ) {

        const optionState =
          state.options[
            distributionOption.id
          ];


        const selectedCount =
          Object.values(
            optionState.selectedValues || {}
          ).filter(Boolean).length;


        if (
          selectedCount > 1 &&
          !optionState.distributionConfirmed
        ) {

          openOnlyStep(
            'distribution'
          );


          return;

        }

      }


      /*
      * Alles voltooid:
      * geen configuratiestap meer openen.
      * De klant komt bij het overzicht.
      */

      openOnlyStep(
        null
      );

    }


    /* =========================================================
       ALGEMENE KEUZEKAART
       ========================================================= */

    function createChoiceCard(
      data
    ) {

      const card =
        document.createElement(
          'button'
        );


      card.type =
        'button';


      card.className =
        'ecobos-choice-card';


      if (
        data.selected
      ) {

        card.classList.add(
          'is-selected'
        );

      }


      let imageHtml =
        '';


      if (
        data.image
      ) {

        imageHtml =

          '<div class="ecobos-choice-card__image">' +

            '<img src="' +
              data.image +
              '" alt="' +
              data.label +
            '">' +

          '</div>';

      }


      card.innerHTML =

        imageHtml +

        '<div class="ecobos-choice-card__footer">' +

          '<span class="ecobos-choice-card__label">' +
            data.label +
          '</span>' +

          '<span class="ecobos-choice-card__check">' +
            '&#10003;' +
          '</span>' +

        '</div>';


      return card;

    }

    /* =========================================================
      AUTOMATISCHE AANTALVERDELING
      ========================================================= */

    function ensureQuantityDistribution(
      option
    ) {

      const optionState =
        state.options[
          option.id
        ];


      if (!optionState) {
        return;
      }


      /*
      * Verzamel alle geselecteerde waarden.
      */

      const selectedCodes =
        Object.keys(
          optionState.selectedValues
        )
          .filter(
            function(code) {

              return Boolean(
                optionState
                  .selectedValues[
                    code
                  ]
              );

            }
          )
          .sort();


      /*
      * Geen selectie:
      * nog geen verdeling mogelijk.
      */

      if (
        !selectedCodes.length
      ) {

        optionState.distribution =
          {};


        optionState.distributionContext = {
          quantity: null,
          selectionKey: null
        };


        optionState.manuallyAdjusted =
          false;


        return;

      }


      const quantity =
        parseInt(
          state.quantity,
          10
        );


      if (
        !Number.isFinite(
          quantity
        ) ||
        quantity <= 0
      ) {
        return;
      }


      /*
      * Door de codes te sorteren krijgen
      * dezelfde gekozen waarden altijd
      * dezelfde sleutel.
      */

      const selectionKey =
        selectedCodes.join(
          '|'
        );


      const context =
        optionState
          .distributionContext ||
        {};


      /*
      * Zelfde totaal + zelfde selectie?
      *
      * Dan laten we de bestaande verdeling
      * volledig met rust. Ook wanneer de
      * klant ze handmatig heeft aangepast.
      */

      if (
        context.quantity ===
          quantity &&
        context.selectionKey ===
          selectionKey
      ) {

        return;

      }


      /*
      * Totaal of selectie is veranderd.
      *
      * Maak opnieuw een zo gelijk mogelijke
      * automatische verdeling.
      */

      const numberOfValues =
        selectedCodes.length;


      const baseAmount =
        Math.floor(
          quantity /
          numberOfValues
        );


      let remainder =
        quantity %
        numberOfValues;


      const distribution =
        {};


      selectedCodes.forEach(
        function(code) {

          distribution[code] =
            baseAmount;


          if (
            remainder > 0
          ) {

            distribution[code] +=
              1;


            remainder -=
              1;

          }

        }
      );


      optionState.distribution =
        distribution;


      optionState.distributionContext = {
        quantity:
          quantity,

        selectionKey:
          selectionKey
      };


      /*
      * Nieuwe automatische verdeling,
      * dus eventuele oude handmatige
      * aanpassing vervalt.
      */

      optionState.manuallyAdjusted =
        false;

    }

    /* =========================================================
      AANTALVERDELING VALIDEREN
      ========================================================= */

    function getQuantityDistributionValidation(
      option
    ) {

      const optionState =
        state.options[
          option.id
        ];


      if (!optionState) {

        return {
          valid: false,
          selectedCount: 0,
          total: 0
        };

      }


      const selectedCodes =
        Object.keys(
          optionState.selectedValues
        ).filter(
          function(code) {

            return Boolean(
              optionState.selectedValues[
                code
              ]
            );

          }
        );


      if (
        option.required &&
        !selectedCodes.length
      ) {

        return {
          valid: false,
          selectedCount: 0,
          total: 0
        };

      }


      /*
      * Bij één gekozen waarde is er
      * geen aparte verdeling nodig.
      * Die krijgt gewoon state.quantity.
      */

      if (
        selectedCodes.length === 1
      ) {

        return {
          valid: true,
          selectedCount: 1,
          total: state.quantity
        };

      }


      let total =
        0;


      selectedCodes.forEach(
        function(code) {

          total +=
            Number(
              optionState.distribution[
                code
              ] || 0
            );

        }
      );


      /*
      * De verdeling bepaalt voortaan
      * zelf het totale bestelaantal.
      */

      const requiredMinimumQuantity =
        getRequiredMinimumQuantity();


      const quantities =
        Array.isArray(
          config.quantity.presets
        )
          ? config.quantity.presets
          : [];


      const baseMinimumQuantity =
        quantities.length
          ? Math.min(
              ...quantities.map(Number)
            )
          : 1;


      const minimumQuantity =
        Math.max(
          baseMinimumQuantity,
          requiredMinimumQuantity
        );


      return {

        valid:
          total >=
          minimumQuantity,

        selectedCount:
          selectedCodes.length,

        total:
          total,

        minimumQuantity:
          minimumQuantity

      };

    }

    /* =========================================================
      AANTALVERDELING
      ========================================================= */

    function renderQuantityDistribution(
      option
    ) {

      const container =
        root.querySelector(
          '[data-option-content="' +
          option.id +
          '"]'
        );


      if (!container) {
        return;
      }


      container.innerHTML =
        '';


      const optionState =
        state.options[
          option.id
        ];


      if (
        !optionState ||
        !Array.isArray(
          option.dimensions
        )
      ) {
        return;
      }

      ensureQuantityDistribution(
        option
      );


      option.dimensions.forEach(
        function(dimension) {

          const cards =
            document.createElement(
              'div'
            );


          cards.className =
            'ecobos-choice-cards';


          (
            dimension.values || []
          ).forEach(
            function(value) {

              const selected =
                Boolean(
                  optionState
                    .selectedValues[
                      value.code
                    ]
                );


              /*
              * Reeds gekozen waarden niet opnieuw
              * als keuzekaart tonen.
              *
              * Ze blijven wel gewoon geselecteerd
              * in de state en zichtbaar in de
              * samenvatting van de stap.
              */

              if (
                selected
              ) {
                return;
              }


              const card =
                createChoiceCard({
                  label:
                    value.name,

                  selected:
                    false
                });


              card.dataset.distributionValue =
                value.code;


              card.dataset.optionId =
                option.id;


              cards.appendChild(
                card
              );

            }
          );


          container.appendChild(
            cards
          );
        }
      );
    }

    function renderDistributionStep() {

      const container =
        root.querySelector(
          '[data-distribution-step-content]'
        );


      if (!container) {
        return;
      }


      container.innerHTML =
        '';

      const step =
        root.querySelector(
          '[data-distribution-step]'
        );


      if (!step) {
        return;
      }

      /*
      * Zoek de aantalverdeling.
      *
      * Voorlopig hebben we er één,
      * maar dit blijft generiek.
      */

      const option =
        config.options.find(
          function(option) {

            return (
              option.type ===
              'quantity_distribution'
            );

          }
        );


      if (!option) {
        return;
      }


      const optionState =
        state.options[
          option.id
        ];


      if (!optionState) {
        return;
      }


      ensureQuantityDistribution(
        option
      );


      const selectedValues =
        [];


      option.dimensions.forEach(
        function(dimension) {

          (
            dimension.values || []
          ).forEach(
            function(value) {

              if (
                optionState.selectedValues[
                  value.code
                ]
              ) {

                selectedValues.push({
                  code:
                    value.code,

                  name:
                    value.name
                });

              }

            }
          );

        }
      );


      /*
      * Bij één gekozen waarde is
      * geen handmatige verdeling nodig.
      */

      if (
        selectedValues.length <= 1
      ) {

        step.hidden =
          true;


        setStepOpen(
          step,
          false
        );


        return;

      }


      /*
      * Twee of meer gekozen waarden:
      * de verdelingsstap wordt relevant.
      */

      step.hidden =
        false;


      selectedValues.forEach(
        function(value) {

          const row =
            document.createElement(
              'div'
            );


          row.className =
            'ecobos-quantity-distribution__row';


          const label =
            document.createElement(
              'label'
            );


          label.className =
            'ecobos-quantity-distribution__label';


          label.textContent =
            value.name;


          const input =
            document.createElement(
              'input'
            );


          input.type =
            'number';


          input.min =
            '0';


          input.step =
            '1';


          input.value =
            optionState.distribution[
              value.code
            ] || 0;


          input.className =
            'ecobos-quantity-distribution__input';


          input.dataset.distributionInput =
            value.code;


          input.dataset.optionId =
            option.id;


          row.appendChild(
            label
          );


          row.appendChild(
            input
          );


          container.appendChild(
            row
          );

        }
      );

      const totalRow =
        document.createElement(
          'div'
        );


      totalRow.className =
        'ecobos-quantity-distribution__total';


      const validation =
        getQuantityDistributionValidation(
          option
        );

      if (
        validation.valid
      ) {

        totalRow.textContent =
          'Totaal: ' +
          validation.total +
          ' stuks';


        totalRow.classList.remove(
          'has-error'
        );


        totalRow.classList.add(
          'is-valid'
        );

      }

      else {

        totalRow.classList.remove(
          'is-valid'
        );


        totalRow.classList.add(
          'has-error'
        );


        totalRow.textContent =
          'Totaal: ' +
          validation.total +
          ' stuks — minimum ' +
          validation.minimumQuantity +
          ' stuks';

      }


      container.appendChild(
        totalRow
      );

      const confirmButton =
        document.createElement(
          'button'
        );


      confirmButton.type =
        'button';


      confirmButton.className =
        'ecobos-distribution-confirm';


      confirmButton.textContent =
        'Verdeling bevestigen';


      confirmButton.dataset.confirmDistribution =
        option.id;


      confirmButton.disabled =
        !validation.valid;


      container.appendChild(
        confirmButton
      );

    }

    function confirmDistribution(
      optionId
    ) {

      const option =
        getOption(
          optionId
        );


      const optionState =
        state.options[
          optionId
        ];


      if (
        !option ||
        !optionState
      ) {
        return;
      }


      const validation =
        getQuantityDistributionValidation(
          option
        );


      if (
        !validation.valid
      ) {
        return;
      }


      /*
      * Vanaf dit moment wordt het totaal
      * van de verdeling het bestelde aantal.
      */

      state.quantity =
        validation.total;


      state.quantityConfirmed =
        true;


      /*
      * Deze handmatige verdeling hoort nu
      * bij het nieuwe totale aantal.
      */

      const selectedCodes =
        Object.keys(
          optionState.selectedValues
        )
          .filter(
            function(code) {

              return Boolean(
                optionState.selectedValues[
                  code
                ]
              );

            }
          )
          .sort();


      optionState.distributionContext = {

        quantity:
          state.quantity,

        selectionKey:
          selectedCodes.join(
            '|'
          )

      };


      optionState.manuallyAdjusted =
        true;

      optionState.distributionConfirmed =
        true;

      /*
      * Nu pas alles opnieuw berekenen.
      */

      updateConfigurator();


      /*
      * Verdelingsstap sluiten.
      */

      setStepOpen(
        getStep(
          'distribution'
        ),
        false
      );

    }

    function toggleDistributionValue(
      optionId,
      valueCode
    ) {

      const option =
        getOption(
          optionId
        );


      const optionState =
        state.options[
          optionId
        ];


      if (
        !option ||
        !optionState
      ) {
        return;
      }


      const isSelected =
        Boolean(
          optionState.selectedValues[
            valueCode
          ]
        );


      /*
      * WIJZIGMODUS
      *
      * Als we een bestaande waarde aan
      * het vervangen zijn en de klant
      * kiest een andere waarde, vervangen
      * we de oude door de nieuwe.
      */

      if (
        optionState.editingValue &&
        !isSelected
      ) {

        const oldValueCode =
          optionState.editingValue;


        /*
        * Oude waarde verwijderen.
        */

        optionState.selectedValues[
          oldValueCode
        ] =
          false;


        delete optionState.distribution[
          oldValueCode
        ];


        /*
        * Nieuwe waarde selecteren.
        */

        optionState.selectedValues[
          valueCode
        ] =
          true;


        /*
        * Wijzigmodus beëindigen.
        */

        optionState.editingValue =
          null;


        optionState.manuallyAdjusted =
          false;


        optionState.distributionConfirmed =
          false;


        renderQuantityDistribution(
          option
        );


        updateConfigurator();


        openNextStep(
          optionId
        );


        return;

      }


      /*
      * NORMALE SELECTIE
      */

      /*
      * Bij een verplichte verdeling
      * moet minstens één waarde
      * geselecteerd blijven.
      */

      if (
        option.required &&
        isSelected
      ) {

        const selectedCount =
          Object.values(
            optionState.selectedValues
          ).filter(Boolean).length;


        if (
          selectedCount <= 1
        ) {
          return;
        }

      }


      optionState.selectedValues[
        valueCode
      ] =
        !isSelected;


      optionState.distributionConfirmed =
        false;


      renderQuantityDistribution(
        option
      );


      updateConfigurator();


      /*
      * NIEUWE WAARDE GEKOZEN
      */

      if (
        !isSelected
      ) {

        openNextStep(
          optionId
        );

      }

    }

    function editDistributionValue(
      optionId,
      valueCode
    ) {

      const option =
        getOption(
          optionId
        );


      const optionState =
        state.options[
          optionId
        ];


      if (
        !option ||
        !optionState
      ) {
        return;
      }


      if (
        !optionState.selectedValues[
          valueCode
        ]
      ) {
        return;
      }


      /*
      * Onthouden welke bestaande
      * waarde vervangen moet worden.
      */

      optionState.editingValue =
        valueCode;


      /*
      * De keuzestap openen.
      */

      openOnlyStep(
        'option:' +
        optionId
      );


      renderQuantityDistribution(
        option
      );

    }

    function removeDistributionValue(
      optionId,
      valueCode
    ) {

      const option =
        getOption(
          optionId
        );


      const optionState =
        state.options[
          optionId
        ];


      if (
        !option ||
        !optionState
      ) {
        return;
      }


      /*
      * Alleen verwijderen als er
      * meer dan één waarde gekozen is.
      */

      const selectedCount =
        Object.values(
          optionState.selectedValues || {}
        ).filter(Boolean).length;


      if (
        selectedCount <= 1
      ) {
        return;
      }


      /*
      * Waarde verwijderen.
      */

      optionState.selectedValues[
        valueCode
      ] =
        false;


      delete optionState.distribution[
        valueCode
      ];


      /*
      * De verdeling moet opnieuw
      * bevestigd worden.
      */

      optionState.distributionConfirmed =
        false;


      optionState.manuallyAdjusted =
        false;


      /*
      * Configurator opnieuw bijwerken.
      */

      renderQuantityDistribution(
        option
      );


      updateConfigurator();

    }

    function addDistributionValue(
      optionId
    ) {

      const option =
        getOption(
          optionId
        );


      if (
        !option ||
        option.type !==
        'quantity_distribution'
      ) {
        return;
      }


      openOnlyStep(
        'option:' +
        optionId
      );

    }

    /* =========================================================
       SINGLE CHOICE
       ========================================================= */

    function renderSingleChoice(
      option
    ) {

      const container =
        root.querySelector(
          '[data-option-content="' +
          option.id +
          '"]'
        );


      if (!container) {
        return;
      }


      container.innerHTML =
        '';


      const cards =
        document.createElement(
          'div'
        );


      cards.className =
        'ecobos-choice-cards';


      const selectedChoice =
        state.options[
          option.id
        ].choice;


      option.choices.forEach(
        function(choice) {

          const card =
            createChoiceCard(
              {

                label:
                  choice.label,

                image:
                  choice.image,

                selected:
                  selectedChoice ===
                  choice.id

              }
            );


          card.dataset.singleChoice =
            choice.id;


          card.dataset.optionId =
            option.id;


          cards.appendChild(
            card
          );

        }
      );


      container.appendChild(
        cards
      );

    }


    function selectSingleChoice(
      optionId,
      choiceId
    ) {

      state.options[
        optionId
      ].choice =
        choiceId;


      const option =
        getOption(
          optionId
        );


      renderSingleChoice(
        option
      );


      updateConfigurator();


      openNextStep(
        optionId
      );

    }


    /* =========================================================
       PERSONALISATIE
       ========================================================= */

    function renderPersonalisation(
      option
    ) {

      const container =
        root.querySelector(
          '[data-option-content="' +
          option.id +
          '"]'
        );


      if (!container) {
        return;
      }


      container.innerHTML =
        '';


      const optionState =
        state.options[
          option.id
        ];


      const completedPositions =
        getCompletedPositions(
          option
        );


      const cards =
        document.createElement(
          'div'
        );


      cards.className =
        'ecobos-choice-cards';


      /*
      * WIJZIG KEUZE
      *
      * Toon:
      * - de positie die momenteel gewijzigd wordt;
      * - alle posities die nog niet gekozen zijn;
      * - Geen personalisatie.
      *
      * Andere reeds gekozen posities worden
      * hier niet opnieuw aangeboden.
      */

      if (
        optionState.editingPosition
      ) {

        option.positions.forEach(
          function(position) {

            const positionState =
              optionState.positions[
                position.id
              ];


            /*
            * De positie die we momenteel
            * wijzigen altijd tonen.
            */

            if (
              position.id ===
              optionState.editingPosition
            ) {

              cards.appendChild(
                createPositionCard(
                  option,
                  position
                )
              );

              return;

            }


            /*
            * Een andere positie alleen tonen
            * wanneer die nog niet gekozen is.
            */

            if (
              !positionState.enabled ||
              !positionState.method
            ) {

              cards.appendChild(
                createPositionCard(
                  option,
                  position
                )
              );

            }

          }
        );


        /*
        * Geen personalisatie alleen tonen
        * wanneer er maximaal één gekozen
        * personalisatiepositie is.
        *
        * Bij meerdere gekozen posities zou
        * deze keuze immers alle bestaande
        * personalisaties verwijderen.
        */

        if (
          completedPositions.length === 1 &&
          option.noPersonalisation &&
          option.noPersonalisation.enabled
        ) {

          cards.appendChild(
            createNoPersonalisationCard(
              option
            )
          );

        }

      }


      /*
       * EXTRA POSITIE
       */

      else if (
        optionState.addingExtraPosition
      ) {

        getAvailablePositions(
          option
        ).forEach(
          function(position) {

            cards.appendChild(
              createPositionCard(
                option,
                position
              )
            );

          }
        );

      }


      /*
       * NORMAAL
       */

      else {

        option.positions.forEach(
          function(position) {

            const positionState =
              optionState.positions[
                position.id
              ];


            if (
              positionState.enabled &&
              positionState.method
            ) {

              return;

            }


            cards.appendChild(
              createPositionCard(
                option,
                position
              )
            );

          }
        );


        if (
          completedPositions.length ===
            0 &&
          option.noPersonalisation &&
          option.noPersonalisation.enabled
        ) {

          cards.appendChild(
            createNoPersonalisationCard(
              option
            )
          );

        }

      }


      container.appendChild(
        cards
      );


      renderMethodSelector(
        option,
        container
      );


      /*
      * INFO BESTANDEN
      *
      * Alleen tonen zodra minstens één
      * personalisatie volledig gekozen is.
      */

      const fileInfo =
        document.createElement(
          'div'
        );


      fileInfo.className =
        'ecobos-personalisation-file-info';


      fileInfo.textContent =
        'Upload je bestanden bij de checkout of later via mail. ' +
        'We kijken alles na en sturen je nog een definitieve drukproef ter goedkeuring.';


      container.appendChild(
        fileInfo
      );

    }


    function createPositionCard(
      option,
      position
    ) {

      const optionState =
        state.options[
          option.id
        ];


      const card =
        createChoiceCard(
          {

            label:
              position.label,

            image:
              position.image,

            selected:
              optionState.activePosition ===
              position.id

          }
        );


      card.dataset.positionId =
        position.id;


      card.dataset.optionId =
        option.id;


      return card;

    }


    function createNoPersonalisationCard(
      option
    ) {

      const optionState =
        state.options[
          option.id
        ];


      const noPersonalisation =
        option.noPersonalisation;


      const card =
        createChoiceCard(
          {

            label:
              noPersonalisation.label,

            image:
              noPersonalisation.image,

            selected:
              optionState.noPersonalisation

          }
        );


      card.dataset.noPersonalisation =
        'true';


      card.dataset.optionId =
        option.id;


      return card;

    }

        /* =========================================================
       POSITIE SELECTEREN
       ========================================================= */

    function selectPosition(
      optionId,
      positionId
    ) {

      const option =
        getOption(
          optionId
        );


      if (!option) {
        return;
      }


      const optionState =
        state.options[
          optionId
        ];


      if (!optionState) {
        return;
      }


      /*
       * Als we een bestaande positie
       * aan het wijzigen zijn en de klant
       * kiest een andere positie.
       */

      if (
        optionState.editingPosition &&
        optionState.editingPosition !==
          positionId
      ) {

        const oldPositionState =
          optionState.positions[
            optionState.editingPosition
          ];


        if (
          oldPositionState
        ) {

          oldPositionState.enabled =
            false;


          oldPositionState.method =
            null;

        }

      }


      /*
       * Nieuwe positie activeren.
       */

      const positionState =
        optionState.positions[
          positionId
        ];


      if (!positionState) {
        return;
      }


      positionState.enabled =
        true;


      /*
       * Bij een nieuwe positie is er
       * nog geen techniek gekozen.
       *
       * Bij het wijzigen van dezelfde
       * positie behouden we de bestaande
       * techniek totdat de klant een
       * andere techniek kiest.
       */

      if (
        optionState.editingPosition !==
        positionId
      ) {

        positionState.method =
          null;

      }


      optionState.activePosition =
        positionId;


      optionState.noPersonalisation =
        false;


      optionState.addingExtraPosition =
        false;


      renderPersonalisation(
        option
      );


      updateConfigurator();

    }


    /* =========================================================
       GEEN PERSONALISATIE
       ========================================================= */

    function selectNoPersonalisation(
      optionId
    ) {

      const option =
        getOption(
          optionId
        );


      if (!option) {
        return;
      }


      const optionState =
        state.options[
          optionId
        ];


      if (!optionState) {
        return;
      }


      optionState.noPersonalisation =
        true;


      optionState.activePosition =
        null;


      optionState.addingExtraPosition =
        false;


      optionState.editingPosition =
        null;


      /*
       * Alle bestaande posities wissen.
       */

      option.positions.forEach(
        function(position) {

          const positionState =
            optionState.positions[
              position.id
            ];


          if (!positionState) {
            return;
          }


          positionState.enabled =
            false;


          positionState.method =
            null;

        }
      );


      renderPersonalisation(
        option
      );


      updateConfigurator();


      openNextStep(
        optionId
      );

    }


    /* =========================================================
       PERSONALISATIETECHNIEK
       ========================================================= */

    function renderMethodSelector(
      option,
      container
    ) {

      const optionState =
        state.options[
          option.id
        ];


      if (
        !optionState.activePosition
      ) {

        return;

      }


      const position =
        getPosition(
          option,
          optionState.activePosition
        );


      if (!position) {
        return;
      }


      const positionState =
        optionState.positions[
          position.id
        ];


      if (!positionState) {
        return;
      }


      const methodWrapper =
        document.createElement(
          'div'
        );


      methodWrapper.className =
        'ecobos-method-selector';


      const title =
        document.createElement(
          'div'
        );


      title.className =
        'ecobos-method-selector__title';


      title.textContent =
        'Kies de personalisatietechniek voor ' +
        position.label;


      methodWrapper.appendChild(
        title
      );


      const methods =
        document.createElement(
          'div'
        );


      methods.className =
        'ecobos-methods';


      /*
       * option.methods is in onze huidige
       * JSON een object:
       *
       * {
       *   "laser": {...},
       *   "print1": {...}
       * }
       */

      Object.keys(
        option.methods || {}
      ).forEach(
        function(methodId) {

          const method =
            option.methods[
              methodId
            ];


          /*
           * Optioneel kan een positie
           * bepaalde technieken beperken
           * via position.methods.
           */

          if (
            Array.isArray(
              position.methods
            ) &&
            !position.methods.includes(
              methodId
            )
          ) {

            return;

          }


          const button =
            document.createElement(
              'button'
            );


          button.type =
            'button';


          button.className =
            'ecobos-method';


          button.dataset.methodId =
            methodId;


          button.dataset.optionId =
            option.id;


          if (
            positionState.method ===
            methodId
          ) {

            button.classList.add(
              'is-selected'
            );

          }


          let priceText =
            '';


          const methodPrice =
            getResolvedItemPrice(
              method,
              state.quantity,
              methodId
            );


          if (
            methodPrice > 0
          ) {

            priceText =
              '<span class="ecobos-method__price">' +
                '+ ' +
                money(
                  methodPrice
                ) +
                ' / stuk' +
              '</span>';

          }


          button.innerHTML =

            '<span class="ecobos-method__content">' +

              '<strong class="ecobos-method__label">' +
                method.label +
              '</strong>' +

              priceText +

            '</span>' +

            '<span class="ecobos-method__check">' +
              '&#10003;' +
            '</span>';


          methods.appendChild(
            button
          );

        }
      );


      methodWrapper.appendChild(
        methods
      );


      container.appendChild(
        methodWrapper
      );

    }


    function selectMethod(
      optionId,
      methodId
    ) {

      const option =
        getOption(
          optionId
        );


      if (!option) {
        return;
      }


      const optionState =
        state.options[
          optionId
        ];


      if (
        !optionState ||
        !optionState.activePosition
      ) {

        return;
      }


      const positionId =
        optionState.activePosition;


      const positionState =
        optionState.positions[
          positionId
        ];


      if (!positionState) {
        return;
      }


      if (
        !option.methods ||
        !option.methods[
          methodId
        ]
      ) {

        return;
      }


      positionState.enabled =
        true;


      positionState.method =
        methodId;


      optionState.activePosition =
        null;


      optionState.addingExtraPosition =
        false;


      optionState.editingPosition =
        null;


      optionState.noPersonalisation =
        false;


      renderPersonalisation(
        option
      );


      updateConfigurator();


      /*
       * Na de eerste personalisatie
       * gaan we automatisch verder.
       *
       * Een extra positie kan de klant
       * nadien via "+ extra positie"
       * toevoegen.
       */

      openNextStep(
        optionId
      );

    }


    /* =========================================================
       EXTRA POSITIE TOEVOEGEN
       ========================================================= */

        function addExtraPosition(
      optionId
    ) {

      const option =
        getOption(
          optionId
        );


      if (!option) {
        return;
      }


      const optionState =
        state.options[
          optionId
        ];


      if (!optionState) {
        return;
      }


      const available =
        getAvailablePositions(
          option
        );


      if (
        !available.length
      ) {

        return;

      }


      optionState.addingExtraPosition =
        true;


      optionState.editingPosition =
        null;


      optionState.activePosition =
        null;


      optionState.noPersonalisation =
        false;


      /*
       * BELANGRIJK:
       * Open de personalisatiestap.
       */

      openOnlyStep(
        'option:' +
        optionId
      );


      renderPersonalisation(
        option
      );


      updateConfigurator();

    }


    /* =========================================================
       POSITIE WIJZIGEN
       ========================================================= */

        function editPosition(
      optionId,
      positionId
    ) {

      const option =
        getOption(
          optionId
        );


      if (!option) {
        return;
      }


      const optionState =
        state.options[
          optionId
        ];


      if (!optionState) {
        return;
      }


      const positionState =
        optionState.positions[
          positionId
        ];


      if (
        !positionState ||
        !positionState.enabled
      ) {

        return;

      }


      optionState.editingPosition =
        positionId;


      optionState.addingExtraPosition =
        false;


      optionState.activePosition =
        positionId;


      /*
       * BELANGRIJK:
       * Open de personalisatiestap.
       */

      openOnlyStep(
        'option:' +
        optionId
      );


      renderPersonalisation(
        option
      );


      updateConfigurator();

    }


    /* =========================================================
       POSITIE VERWIJDEREN
       ========================================================= */

    function removePosition(
      optionId,
      positionId
    ) {

      const option =
        getOption(
          optionId
        );


      if (!option) {
        return;
      }


      const optionState =
        state.options[
          optionId
        ];


      if (!optionState) {
        return;
      }


      const positionState =
        optionState.positions[
          positionId
        ];


      if (!positionState) {
        return;
      }


      positionState.enabled =
        false;


      positionState.method =
        null;


      if (
        optionState.activePosition ===
        positionId
      ) {

        optionState.activePosition =
          null;

      }


      if (
        optionState.editingPosition ===
        positionId
      ) {

        optionState.editingPosition =
          null;

      }


      optionState.addingExtraPosition =
        false;


      renderPersonalisation(
        option
      );


      updateConfigurator();

    }


        /* =========================================================
       SAMENVATTING VAN DE STAPPEN
       ========================================================= */

    function updateStepCompletion() {

      config.options.forEach(
        function(option) {

          const step =
            getStep(
              'option:' +
              option.id
            );


          if (!step) {
            return;
          }


          const optionState =
            state.options[
              option.id
            ];


          let complete =
            false;


          /*
          * PERSONALISATIE
          */
          if (
            option.type ===
            'personalisation'
          ) {

            complete =
              Boolean(
                optionState.noPersonalisation
              ) ||
              getCompletedPositions(
                option
              ).length > 0;

          }


          /*
          * SINGLE CHOICE
          */
          else if (
            option.type ===
            'single_choice'
          ) {

            complete =
              Boolean(
                optionState.choice
              );

          }


          /*
          * AANTALVERDELING:
          * minstens één waarde gekozen.
          *
          * De effectieve aantallenverdeling
          * wordt later apart bevestigd.
          */
          else if (
            option.type ===
            'quantity_distribution'
          ) {

            complete =
              Object.values(
                optionState.selectedValues || {}
              ).some(Boolean);

          }


          step.classList.toggle(
            'is-complete',
            complete
          );


          const number =
            step.querySelector(
              '.ecobos-step__number'
            );


          if (number) {

            if (complete) {

              number.textContent =
                '✓';

            }

            else {

              const optionIndex =
                config.options.findIndex(
                  function(currentOption) {

                    return (
                      currentOption.id ===
                      option.id
                    );

                  }
                );


              number.textContent =
                optionIndex + 1;

            }

          }

        }
      );


      /*
      * AANTAL
      */

      const quantityStep =
        getStep(
          'quantity'
        );


      if (
        quantityStep
      ) {

        quantityStep.classList.toggle(
          'is-complete',
          state.quantityConfirmed
        );


        const quantityNumber =
          quantityStep.querySelector(
            '[data-quantity-step-number]'
          );


        if (
          quantityNumber
        ) {

          quantityNumber.textContent =
            state.quantityConfirmed
              ? '✓'
              : config.options.length + 1;

        }

      }

      /*
      * VERDELING
      */

      const distributionStep =
        getStep(
          'distribution'
        );


      if (
        distributionStep
      ) {

        const distributionOption =
          config.options.find(
            function(option) {

              return (
                option.type ===
                'quantity_distribution'
              );

            }
          );


        const distributionConfirmed =
          Boolean(
            distributionOption &&
            state.options[
              distributionOption.id
            ] &&
            state.options[
              distributionOption.id
            ].distributionConfirmed
          );


        distributionStep.classList.toggle(
          'is-complete',
          distributionConfirmed
        );


        const distributionNumber =
          distributionStep.querySelector(
            '[data-distribution-step-number]'
          );


        if (
          distributionNumber
        ) {

          distributionNumber.textContent =
            distributionConfirmed
              ? '✓'
              : config.options.length + 2;

        }

      }

    }

    function updateStepSummaries() {

      config.options.forEach(
        function(option) {

          const summary =
            root.querySelector(
              '[data-step-summary="' +
              option.id +
              '"]'
            );


          if (!summary) {
            return;
          }


          const optionState =
            state.options[
              option.id
            ];


          /* =====================================================
             PERSONALISATIE
             ===================================================== */

          if (
            option.type ===
            'personalisation'
          ) {

            if (
              optionState.noPersonalisation
            ) {

              summary.innerHTML =
                '';


              const summaryContent =
                document.createElement(
                  'span'
                );


              summaryContent.className =
                'ecobos-step-summary__content';


              const row =
                document.createElement(
                  'span'
                );


              row.className =
                'ecobos-step-summary__row';


              /*
              * GEEN PERSONALISATIE
              */

              const text =
                document.createElement(
                  'span'
                );


              text.className =
                'ecobos-step-summary__text';


              text.textContent =
                (
                  option.noPersonalisation &&
                  option.noPersonalisation.label
                )
                  ? option.noPersonalisation.label
                  : 'Geen personalisatie';


              row.appendChild(
                text
              );


              /*
              * WIJZIG
              */

              const editButton =
                document.createElement(
                  'span'
                );


              editButton.className =
                'ecobos-step-summary__edit';


              editButton.textContent =
                'Wijzig';


              editButton.dataset.editNoPersonalisation =
                option.id;


              editButton.setAttribute(
                'role',
                'button'
              );


              editButton.setAttribute(
                'tabindex',
                '0'
              );


              row.appendChild(
                editButton
              );


              summaryContent.appendChild(
                row
              );


              summary.appendChild(
                summaryContent
              );


              return;

            }


            const completed =
              getCompletedPositions(
                option
              );


            if (
              !completed.length
            ) {

              summary.textContent =
                'Maak je keuze';


              return;

            }


            summary.innerHTML =
              '';


            const summaryContent =
              document.createElement(
                'span'
              );


            summaryContent.className =
              'ecobos-step-summary__content';


            completed.forEach(
              function(position) {

                const positionState =
                  optionState.positions[
                    position.id
                  ];


                const method =
                  option.methods[
                    positionState.method
                  ];


                if (!method) {
                  return;
                }


                const row =
                  document.createElement(
                    'span'
                  );


                row.className =
                  'ecobos-step-summary__row';


                const text =
                  document.createElement(
                    'span'
                  );


                text.className =
                  'ecobos-step-summary__text';


                text.textContent =
                  position.label +
                  ': ' +
                  method.label;


                row.appendChild(
                  text
                );


                /* =============================================
                   WIJZIG
                   Geen button, want dit element staat binnen
                   de accordion-button.
                   ============================================= */

                const editButton =
                  document.createElement(
                    'span'
                  );


                editButton.className =
                  'ecobos-step-summary__edit';


                editButton.textContent =
                  'Wijzig';


                editButton.dataset.editPosition =
                  position.id;


                editButton.dataset.optionId =
                  option.id;


                editButton.setAttribute(
                  'role',
                  'button'
                );


                editButton.setAttribute(
                  'tabindex',
                  '0'
                );


                row.appendChild(
                  editButton
                );


                /* =============================================
                  VERWIJDER
                  Alleen tonen bij meer dan één positie
                  ============================================= */

                if (
                  completed.length >
                  1
                ) {

                  const removeButton =
                    document.createElement(
                      'span'
                    );


                  removeButton.className =
                    'ecobos-step-summary__remove';


                  removeButton.textContent =
                    '×';


                  removeButton.dataset.removePosition =
                    position.id;


                  removeButton.dataset.optionId =
                    option.id;


                  removeButton.setAttribute(
                    'role',
                    'button'
                  );


                  removeButton.setAttribute(
                    'tabindex',
                    '0'
                  );


                  removeButton.setAttribute(
                    'aria-label',
                    position.label +
                    ' verwijderen'
                  );


                  row.appendChild(
                    removeButton
                  );

                }


                /*
                * De rij altijd toevoegen,
                * ook wanneer er maar één positie is.
                */

                summaryContent.appendChild(
                  row
                );
              }
            );


            /* =================================================
               EXTRA POSITIE TOEVOEGEN
               ================================================= */

            const available =
              getAvailablePositions(
                option
              );


            if (
              available.length
            ) {

              const addButton =
                document.createElement(
                  'span'
                );


              addButton.className =
                'ecobos-step-summary__add';


              addButton.textContent =
                '+ extra positie toevoegen';


              addButton.dataset.addPosition =
                'true';


              addButton.dataset.optionId =
                option.id;


              addButton.setAttribute(
                'role',
                'button'
              );


              addButton.setAttribute(
                'tabindex',
                '0'
              );


              summaryContent.appendChild(
                addButton
              );

            }


            summary.appendChild(
              summaryContent
            );

          }

          else if (
            option.type ===
            'quantity_distribution'
          ) {

            const selectedValues =
              [];


            /*
            * Alle gekozen waarden verzamelen.
            */

            (
              option.dimensions || []
            ).forEach(
              function(dimension) {

                (
                  dimension.values || []
                ).forEach(
                  function(value) {

                    if (
                      optionState.selectedValues[
                        value.code
                      ]
                    ) {

                      selectedValues.push(
                        value
                      );

                    }

                  }
                );

              }
            );


            if (
              !selectedValues.length
            ) {

              summary.textContent =
                'Maak je keuze';


              return;

            }


            summary.innerHTML =
              '';


            const summaryContent =
              document.createElement(
                'span'
              );


            summaryContent.className =
              'ecobos-step-summary__content';


            /*
            * Voor iedere gekozen waarde
            * een aparte regel maken.
            */

            selectedValues.forEach(
              function(value) {

                const row =
                  document.createElement(
                    'span'
                  );


                row.className =
                  'ecobos-step-summary__row';


                /*
                * NAAM
                */

                const text =
                  document.createElement(
                    'span'
                  );


                text.className =
                  'ecobos-step-summary__text';


                text.textContent =
                  value.name;


                row.appendChild(
                  text
                );


                /*
                * WIJZIG
                */

                const editButton =
                  document.createElement(
                    'span'
                  );


                editButton.className =
                  'ecobos-step-summary__edit';


                editButton.textContent =
                  'Wijzig';


                editButton.dataset.editDistributionValue =
                  value.code;


                editButton.dataset.optionId =
                  option.id;


                editButton.setAttribute(
                  'role',
                  'button'
                );


                editButton.setAttribute(
                  'tabindex',
                  '0'
                );


                row.appendChild(
                  editButton
                );


                /*
                * VERWIJDER
                *
                * Alleen tonen wanneer er
                * meer dan één waarde gekozen is.
                */

                if (
                  selectedValues.length > 1
                ) {

                  const removeButton =
                    document.createElement(
                      'span'
                    );


                  removeButton.className =
                    'ecobos-step-summary__remove';


                  removeButton.textContent =
                    '×';


                  removeButton.dataset.removeDistributionValue =
                    value.code;


                  removeButton.dataset.optionId =
                    option.id;


                  removeButton.setAttribute(
                    'role',
                    'button'
                  );


                  removeButton.setAttribute(
                    'tabindex',
                    '0'
                  );


                  removeButton.setAttribute(
                    'aria-label',
                    value.name +
                    ' verwijderen'
                  );


                  row.appendChild(
                    removeButton
                  );

                }


                summaryContent.appendChild(
                  row
                );

              }
            );


            /*
            * KIJK OF ER NOG WAARDEN
            * BESCHIKBAAR ZIJN
            */

            let totalValues =
              0;


            (
              option.dimensions || []
            ).forEach(
              function(dimension) {

                totalValues +=
                  (
                    dimension.values || []
                  ).length;

              }
            );


            if (
              selectedValues.length <
              totalValues
            ) {

              const addButton =
                document.createElement(
                  'span'
                );


              addButton.className =
                'ecobos-step-summary__add';


              addButton.textContent =
                '+ nog een ' +
                option.label.toLowerCase() +
                ' kiezen';


              addButton.dataset.addDistributionValue =
                'true';


              addButton.dataset.optionId =
                option.id;


              addButton.setAttribute(
                'role',
                'button'
              );


              addButton.setAttribute(
                'tabindex',
                '0'
              );


              summaryContent.appendChild(
                addButton
              );

            }


            summary.appendChild(
              summaryContent
            );


            return;

          }

          /* =====================================================
             SINGLE CHOICE
             ===================================================== */

          else if (
            option.type ===
            'single_choice'
          ) {

            if (
              !optionState.choice
            ) {

              summary.textContent =
                'Maak je keuze';


              return;

            }


            const choice =
              getChoice(
                option,
                optionState.choice
              );


            if (
              !choice
            ) {

              summary.textContent =
                'Maak je keuze';


              return;

            }


            summary.innerHTML =
              '';


            const summaryContent =
              document.createElement(
                'span'
              );


            summaryContent.className =
              'ecobos-step-summary__content';


            const row =
              document.createElement(
                'span'
              );


            row.className =
              'ecobos-step-summary__row';


            /*
            * GEKOZEN OPTIE
            */

            const text =
              document.createElement(
                'span'
              );


            text.className =
              'ecobos-step-summary__text';


            text.textContent =
              choice.label;


            row.appendChild(
              text
            );


            /*
            * WIJZIG
            */

            const editButton =
              document.createElement(
                'span'
              );


            editButton.className =
              'ecobos-step-summary__edit';


            editButton.textContent =
              'Wijzig';


            editButton.dataset.editSingleChoice =
              option.id;


            editButton.setAttribute(
              'role',
              'button'
            );


            editButton.setAttribute(
              'tabindex',
              '0'
            );


            row.appendChild(
              editButton
            );


            summaryContent.appendChild(
              row
            );


            summary.appendChild(
              summaryContent
            );

          }

        }
      );

      if (
        distributionStepSummary
      ) {

        const option =
          config.options.find(
            function(option) {

              return (
                option.type ===
                'quantity_distribution'
              );

            }
          );


        if (
          option
        ) {

          const optionState =
            state.options[
              option.id
            ];


          const selectedValues =
            [];


          (
            option.dimensions || []
          ).forEach(
            function(dimension) {

              (
                dimension.values || []
              ).forEach(
                function(value) {

                  if (
                    optionState.selectedValues[
                      value.code
                    ]
                  ) {

                    selectedValues.push(
                      value
                    );

                  }

                }
              );

            }
          );


          if (
            selectedValues.length > 1
          ) {

            distributionStepSummary.innerHTML =
              '';


            const summaryContent =
              document.createElement(
                'span'
              );


            summaryContent.className =
              'ecobos-step-summary__content';


            selectedValues.forEach(
              function(value) {

                const row =
                  document.createElement(
                    'span'
                  );


                row.className =
                  'ecobos-step-summary__row';


                const text =
                  document.createElement(
                    'span'
                  );


                text.className =
                  'ecobos-step-summary__text';


                text.textContent =
                  value.name +
                  ': ' +
                  Number(
                    optionState.distribution[
                      value.code
                    ] || 0
                  ) +
                  ' stuks';


                row.appendChild(
                  text
                );


                summaryContent.appendChild(
                  row
                );

              }
            );


            const editRow =
              document.createElement(
                'span'
              );


            editRow.className =
              'ecobos-step-summary__row';


            const editButton =
              document.createElement(
                'span'
              );


            editButton.className =
              'ecobos-step-summary__edit';


            editButton.textContent =
              'Wijzig';


            editButton.dataset.editDistribution =
              'true';


            editButton.setAttribute(
              'role',
              'button'
            );


            editButton.setAttribute(
              'tabindex',
              '0'
            );


            editRow.appendChild(
              editButton
            );


            summaryContent.appendChild(
              editRow
            );


            distributionStepSummary.appendChild(
              summaryContent
            );

          }

        }

      }

      if (
        quantityStepSummary
      ) {

        quantityStepSummary.innerHTML =
          '';


        /*
        * Nog geen aantal door de klant
        * bevestigd: geen samenvatting tonen.
        */

        if (
          !state.quantityConfirmed
        ) {

          const minimumQuantity =
            Math.max(
              config.quantity.minimum,
              getRequiredMinimumQuantity()
            );


          quantityStepSummary.textContent =
            'Minimum aantal: ' +
            minimumQuantity +
            ' stuks';


          return;
        }


        const summaryContent =
          document.createElement(
            'span'
          );


        summaryContent.className =
          'ecobos-step-summary__content';


        const row =
          document.createElement(
            'span'
          );


        row.className =
          'ecobos-step-summary__row';


        /*
        * GEKOZEN AANTAL
        */

        const text =
          document.createElement(
            'span'
          );


        text.className =
          'ecobos-step-summary__text';


        text.textContent =
          state.quantity +
          ' stuks';


        row.appendChild(
          text
        );


        /*
        * WIJZIG
        */

        const editButton =
          document.createElement(
            'span'
          );


        editButton.className =
          'ecobos-step-summary__edit';


        editButton.textContent =
          'Wijzig';


        editButton.dataset.editQuantity =
          'true';


        editButton.setAttribute(
          'role',
          'button'
        );


        editButton.setAttribute(
          'tabindex',
          '0'
        );


        row.appendChild(
          editButton
        );


        summaryContent.appendChild(
          row
        );


        quantityStepSummary.appendChild(
          summaryContent
        );  

      }

    }

    /* =========================================================
       ONDERSTE SAMENVATTING
       ========================================================= */

    function renderSummary() {

      const result =
        calculatePrice(
          state.quantity
        );


      if (
        summaryQuantity
      ) {

        summaryQuantity.textContent =
          state.quantity;

      }


      if (
        summaryUnitPrice
      ) {

        summaryUnitPrice.textContent =
          money(
            result.unitPrice
          );

      }


      if (
        summarySetup
      ) {

        summarySetup.textContent =
          "GRATIS";
      }


      if (
        summaryTotal
      ) {

        summaryTotal.textContent =
          money(
            result.total
          );

      }


      /*
       * Configuratie onderaan tonen.
       */

      if (
        summaryOptions
      ) {

        summaryOptions.innerHTML =
          '';


        config.options.forEach(
          function(option) {

            const optionState =
              state.options[
                option.id
              ];


            if (!optionState) {
              return;
            }


            /*
             * PERSONALISATIE
             */

            if (
              option.type ===
              'personalisation'
            ) {

              if (
                optionState.noPersonalisation
              ) {

                const row =
                  document.createElement(
                    'div'
                  );


                row.className =
                  'ecobos-summary__option';


                const label =
                  document.createElement(
                    'span'
                  );


                label.textContent =
                  option.label;


                const value =
                  document.createElement(
                    'strong'
                  );


                value.textContent =
                  (
                    option.noPersonalisation &&
                    option.noPersonalisation.label
                  )
                    ? option.noPersonalisation.label
                    : 'Geen personalisatie';


                row.appendChild(
                  label
                );


                row.appendChild(
                  value
                );


                summaryOptions.appendChild(
                  row
                );


                return;

              }


              getCompletedPositions(
                option
              ).forEach(
                function(position) {

                  const positionState =
                    optionState.positions[
                      position.id
                    ];


                  const method =
                    option.methods[
                      positionState.method
                    ];


                  if (!method) {
                    return;
                  }


                  const row =
                    document.createElement(
                      'div'
                    );


                  row.className =
                    'ecobos-summary__option';


                  const label =
                    document.createElement(
                      'span'
                    );


                  label.textContent =
                    position.label;


                  const value =
                    document.createElement(
                      'strong'
                    );


                  value.textContent =
                    method.label;


                  row.appendChild(
                    label
                  );


                  row.appendChild(
                    value
                  );


                  summaryOptions.appendChild(
                    row
                  );

                }
              );

            }


            /*
             * SINGLE CHOICE
             */

            else if (
              option.type ===
              'single_choice'
            ) {

              if (
                !optionState.choice
              ) {

                return;

              }


              const choice =
                getChoice(
                  option,
                  optionState.choice
                );


              if (!choice) {
                return;
              }


              const row =
                document.createElement(
                  'div'
                );


              row.className =
                'ecobos-summary__option';


              const label =
                document.createElement(
                  'span'
                );


              label.textContent =
                option.label;


              const value =
                document.createElement(
                  'strong'
                );


              value.textContent =
                choice.label;


              row.appendChild(
                label
              );


              row.appendChild(
                value
              );


              summaryOptions.appendChild(
                row
              );

            }

          }
        );

      }

    }

        /* =========================================================
       PRIJSTABEL
       ========================================================= */

    function getRequiredMinimumQuantity() {

      let minimumQuantity = 0;


      config.options.forEach(
        function(option) {

          const optionState =
            state.options[
              option.id
            ];


          if (!optionState) {
            return;
          }


          /*
          * PERSONALISATIE
          */

          if (
            option.type ===
            'personalisation'
          ) {

            if (
              optionState.noPersonalisation
            ) {
              return;
            }


            getCompletedPositions(
              option
            ).forEach(
              function(position) {

                const positionState =
                  optionState.positions[
                    position.id
                  ];


                if (
                  !positionState ||
                  !positionState.method
                ) {
                  return;
                }


                const method =
                  option.methods[
                    positionState.method
                  ];


                if (!method) {
                  return;
                }


                minimumQuantity =
                  Math.max(
                    minimumQuantity,
                    Number(
                      method.minimumQuantity || 0
                    )
                  );

              }
            );

          }


          /*
          * SINGLE CHOICE
          */

          else if (
            option.type ===
            'single_choice'
          ) {

            if (
              !optionState.choice
            ) {
              return;
            }


            const choice =
              getChoice(
                option,
                optionState.choice
              );


            if (!choice) {
              return;
            }


            minimumQuantity =
              Math.max(
                minimumQuantity,
                Number(
                  choice.minimumQuantity || 0
                )
              );

          }

        }
      );


      return minimumQuantity;

    }

    function ensureValidQuantity() {

      const requiredMinimumQuantity =
        getRequiredMinimumQuantity();


      if (
        !requiredMinimumQuantity ||
        state.quantity >=
        requiredMinimumQuantity
      ) {
        return;
      }


      const quantities =
        Array.isArray(
          config.quantity.presets
        )
          ? config.quantity.presets
          : [];


      const nextValidQuantity =
        quantities.find(
          function(quantity) {

            return (
              Number(quantity) >=
              requiredMinimumQuantity
            );

          }
        );


      if (
        nextValidQuantity !==
        undefined
      ) {

        state.quantity =
          Number(
            nextValidQuantity
          );


        if (
          customQuantityInput
        ) {

          customQuantityInput.value =
            '';

        }

      }

    }

    function renderPriceTable() {

      if (
        !priceTable
      ) {
        return;
      }


      priceTable.innerHTML =
        '';


      const quantities =
        Array.isArray(
          config.quantity.presets
        )
          ? config.quantity.presets
          : [];

        const requiredMinimumQuantity = getRequiredMinimumQuantity();

      quantities.forEach(
        
        function(quantity) {

          const result =
            calculatePrice(
              quantity
            );


          const row =
            document.createElement(
              'button'
            );


          row.type =
            'button';


          row.className =
            'ecobos-price-row';


          row.dataset.quantity =
            quantity;

          const unavailable =
            requiredMinimumQuantity > 0 &&
            quantity <
            requiredMinimumQuantity;


          if (unavailable) {

            row.disabled =
              true;

            row.classList.add(
              'is-disabled'
            );

          }

          if (
            quantity ===
            state.quantity
          ) {

            row.classList.add(
              'is-selected'
            );

          }


          const currentPrice =
            result.unitPrice;


          let savingText =
            '';


          const currentIndex =
            quantities.indexOf(
              quantity
            );


          if (
            currentIndex > 0
          ) {

            const previousQuantity =
              quantities[
                currentIndex - 1
              ];


            const previousResult =
              calculatePrice(
                previousQuantity
              );


            const difference =
              roundMoney(
                previousResult.unitPrice -
                currentPrice
              );


            if (
              difference > 0
            ) {

              savingText =
                '<span class="ecobos-price-row__saving">' +
                  'Bespaar ' +
                  money(
                    difference
                  ) +
                  ' / stuk' +
                '</span>';

            }

          }


          row.innerHTML =

            '<span class="ecobos-price-row__quantity">' +

              '<strong>' +
                quantity +
              '</strong>' +

              '<span>' +
                'stuks' +
              '</span>' +

            '</span>' +


            '<span class="ecobos-price-row__price">' +

              '<strong>' +
                money(
                  currentPrice
                ) +
              '</strong>' +

              '<span>' +
                'per stuk' +
              '</span>' +

            '</span>' +


            savingText;


          priceTable.appendChild(
            row
          );

        }
      );

    }

    function resetDistributionConfirmation() {

      config.options.forEach(
        function(option) {

          if (
            option.type !==
            'quantity_distribution'
          ) {
            return;
          }


          const optionState =
            state.options[
              option.id
            ];


          if (
            optionState
          ) {

            optionState.distributionConfirmed =
              false;

          }

        }
      );

    }

    /* =========================================================
       AANTAL
       ========================================================= */

    function selectQuantity(
      quantity
    ) {

      state.quantity =
        quantity;

      state.quantityConfirmed =
        true;

      resetDistributionConfirmation();

      if (
        customQuantityInput
      ) {

        customQuantityInput.value =
          '';

      }


      updateConfigurator();


      const distributionStep =
        getStep(
          'distribution'
        );


      if (
        distributionStep &&
        !distributionStep.hidden
      ) {

        openOnlyStep(
          'distribution'
        );

      }

      else {

        setStepOpen(
          getStep(
            'quantity'
          ),
          false
        );

      }

    }


    function selectCustomQuantity() {

      if (
        !customQuantityInput
      ) {
        return;
      }


      const quantity =
        parseInt(
          customQuantityInput.value,
          10
        );


      const requiredMinimumQuantity =
        getRequiredMinimumQuantity();


      /*
      * Absoluut minimum:
      * eerste beschikbare staffel.
      */

      const quantities =
        Array.isArray(
          config.quantity.presets
        )
          ? config.quantity.presets
          : [];


      const baseMinimumQuantity =
        quantities.length
          ? Math.min(
              ...quantities.map(Number)
            )
          : 1;


      /*
      * Het hoogste minimum geldt:
      * - basisminimum van het product
      * - minimum van geselecteerde opties
      */

      const minimumQuantity =
        Math.max(
          baseMinimumQuantity,
          requiredMinimumQuantity
        );


      if (
        !quantity ||
        quantity <
        minimumQuantity
      ) {

        alert(
          'Het minimum aantal voor deze configuratie is ' +
          minimumQuantity +
          ' stuks.'
        );


        return;

      }


      state.quantity =
        quantity;

      state.quantityConfirmed =
        true;

      resetDistributionConfirmation();
      updateConfigurator();


      const distributionStep =
        getStep(
          'distribution'
        );


      if (
        distributionStep &&
        !distributionStep.hidden
      ) {

        openOnlyStep(
          'distribution'
        );

      }

      else {

        setStepOpen(
          getStep(
            'quantity'
          ),
          false
        );

      }

    }


    /* =========================================================
       BESTAANDE CONFIGURATIE TERUG INLADEN
       ========================================================= */

    function restoreCartItemForEditing() {

      if (
        !editingCartItemId
      ) {

        return false;

      }


      const cart =
        getEcobosCart();


      const item =
        cart.items.find(
          function(cartItem) {

            return (
              cartItem.id ===
              editingCartItemId
            );

          }
        );


      if (
        !item ||
        !item.state ||
        !item.state.options
      ) {

        console.warn(
          'ECOBOS configurator: het te wijzigen winkelmand-item werd niet gevonden.'
        );


        return false;

      }


      /*
       * Alleen configuratie van
       * dezelfde variant laden.
       */

      if (
        Number(
          item.variantId
        ) !==
        Number(
          variantId
        )
      ) {

        console.warn(
          'ECOBOS configurator: variant komt niet overeen met het winkelmand-item.'
        );


        return false;

      }


      /* =====================================================
         AANTAL
         ===================================================== */

      const savedQuantity =
        parseInt(
          item.quantity,
          10
        );


      if (
        savedQuantity &&
        savedQuantity >=
        config.quantity.minimum
      ) {

        state.quantity =
          savedQuantity;

        state.quantityConfirmed =
          true;

      }


      /* =====================================================
         OPTIES
         ===================================================== */

      config.options.forEach(
        function(option) {

          const savedOption =
            item.state.options[
              option.id
            ];


          const currentOption =
            state.options[
              option.id
            ];


          if (
            !savedOption ||
            !currentOption
          ) {

            return;

          }


          /* ===============================================
             PERSONALISATIE
             =============================================== */

          if (
            option.type ===
            'personalisation'
          ) {

            currentOption.noPersonalisation =
              Boolean(
                savedOption.noPersonalisation
              );


            option.positions.forEach(
              function(position) {

                const savedPosition =
                  savedOption.positions &&
                  savedOption.positions[
                    position.id
                  ];


                const currentPosition =
                  currentOption.positions[
                    position.id
                  ];


                if (
                  !savedPosition ||
                  !currentPosition
                ) {

                  return;

                }


                const methodExists =
                  (
                    savedPosition.method &&
                    option.methods &&
                    option.methods[
                      savedPosition.method
                    ]
                  );


                currentPosition.enabled =
                  Boolean(
                    savedPosition.enabled &&
                    methodExists
                  );


                currentPosition.method =
                  methodExists
                    ? savedPosition.method
                    : null;

              }
            );


            /*
             * Dit zijn tijdelijke UI-staten.
             * Die hoeven we niet terug te zetten.
             */

            currentOption.activePosition =
              null;


            currentOption.addingExtraPosition =
              false;


            currentOption.editingPosition =
              null;

          }


          /* ===============================================
             SINGLE CHOICE
             =============================================== */

          else if (
            option.type ===
            'single_choice'
          ) {

            const choiceExists =
              savedOption.choice
                ? getChoice(
                    option,
                    savedOption.choice
                  )
                : null;


            currentOption.choice =
              choiceExists
                ? savedOption.choice
                : null;

          }

          else if (
            option.type ===
            'quantity_distribution'
          ) {

            /*
            * Alleen waarden terugzetten die
            * nog werkelijk bestaan in de
            * huidige configuratie.
            */

            currentOption.selectedValues =
              {};


            currentOption.distribution =
              {};


            (
              option.dimensions || []
            ).forEach(
              function(dimension) {

                (
                  dimension.values || []
                ).forEach(
                  function(value) {

                    if (
                      savedOption.selectedValues &&
                      savedOption.selectedValues[
                        value.code
                      ]
                    ) {

                      currentOption.selectedValues[
                        value.code
                      ] =
                        true;


                      currentOption.distribution[
                        value.code
                      ] =
                        Number(
                          (
                            savedOption.distribution &&
                            savedOption.distribution[
                              value.code
                            ]
                          ) || 0
                        );

                    }

                  }
                );

              }
            );


            /*
            * Bewaar de huidige situatie als context,
            * zodat ensureQuantityDistribution()
            * de opgeslagen verdeling niet meteen
            * opnieuw automatisch overschrijft.
            */

            const selectedCodes =
              Object.keys(
                currentOption.selectedValues
              )
                .filter(
                  function(code) {

                    return Boolean(
                      currentOption.selectedValues[
                        code
                      ]
                    );

                  }
                )
                .sort();


            currentOption.distributionContext = {

              quantity:
                state.quantity,

              selectionKey:
                selectedCodes.join(
                  '|'
                )

            };


            currentOption.manuallyAdjusted =
              Boolean(
                savedOption.manuallyAdjusted
              );

            currentOption.distributionConfirmed =
              true;

          }

        }
      );


      /*
       * Als het opgeslagen aantal geen
       * standaard preset is, tonen we het
       * ook in het vrije aantalveld.
       */

      if (
        customQuantityInput &&
        !config.quantity.presets.includes(
          state.quantity
        )
      ) {

        customQuantityInput.value =
          state.quantity;

      }


      return true;

    }


    /* =========================================================
       ALLES RENDEREN
       ========================================================= */

    function renderAllOptions() {

      config.options.forEach(
        function(option) {

          if (
            option.type ===
            'personalisation'
          ) {

            renderPersonalisation(
              option
            );

          }


          else if (
            option.type ===
            'single_choice'
          ) {

            renderSingleChoice(
              option
            );

          }

          else if (
            option.type ===
            'quantity_distribution'
          ) {

            renderQuantityDistribution(
              option
            );

          }
        }
      );

    }


    function updateConfigurator() {

      ensureValidQuantity();
      renderPriceTable();
      renderDistributionStep();
      renderSummary();
      updateStepSummaries();
      updateStepCompletion();

    }


    /* =========================================================
       EDIT-MODUS VISUEEL DUIDELIJK MAKEN
       ========================================================= */

    function updateEditModeUI(
      isEditing
    ) {

      if (
        !isEditing
      ) {
        return;
      }


      root.classList.add(
        'is-editing-cart-item'
      );


      if (
        addToCartButton
      ) {

        addToCartButton.textContent =
          'Wijzigingen opslaan';

      }


      /*
       * Optioneel bericht boven of onder
       * de knop wanneer het element bestaat.
       */

      if (
        addToCartMessage
      ) {

        addToCartMessage.hidden =
          false;


        addToCartMessage.textContent =
          'Je wijzigt een bestaande configuratie uit je winkelmandje.';

      }

    }


    /* =========================================================
       EVENT DELEGATION
       ========================================================= */

    root.addEventListener(
      'click',
      function(event) {


        /*
         * =====================================================
         * BELANGRIJK:
         *
         * Acties die IN de accordion-header staan,
         * moeten vóór de algemene accordion-click
         * worden afgehandeld.
         * =====================================================
         */

        /* =====================================================
          VERDELING BEVESTIGEN
          ===================================================== */

        const confirmDistributionButton =
          event.target.closest(
            '[data-confirm-distribution]'
          );


        if (
          confirmDistributionButton
        ) {

          event.preventDefault();
          event.stopPropagation();


          confirmDistribution(
            confirmDistributionButton.dataset.confirmDistribution
          );


          return;
        }


        /* =====================================================
           WIJZIG POSITIE
           ===================================================== */

        const editButton =
          event.target.closest(
            '[data-edit-position]'
          );


        if (
          editButton
        ) {

          event.preventDefault();


          event.stopPropagation();


          editPosition(
            editButton.dataset.optionId,
            editButton.dataset.editPosition
          );


          return;

        }


        /* =====================================================
           VERWIJDER POSITIE
           ===================================================== */

        const removeButton =
          event.target.closest(
            '[data-remove-position]'
          );


        if (
          removeButton
        ) {

          event.preventDefault();


          event.stopPropagation();


          removePosition(
            removeButton.dataset.optionId,
            removeButton.dataset.removePosition
          );


          return;

        }


        /* =====================================================
           EXTRA POSITIE
           ===================================================== */

        const addButton =
          event.target.closest(
            '[data-add-position]'
          );


        if (
          addButton
        ) {

          event.preventDefault();


          event.stopPropagation();


          addExtraPosition(
            addButton.dataset.optionId
          );


          return;

        }

        /* =====================================================
          WIJZIG VERDELING
          ===================================================== */

        const editDistributionStepButton =
          event.target.closest(
            '[data-edit-distribution]'
          );


        if (
          editDistributionStepButton
        ) {

          event.preventDefault();


          event.stopPropagation();


          openOnlyStep(
            'distribution'
          );


          return;

        }

        /* =====================================================
          WIJZIG AANTAL
          ===================================================== */

        const editQuantityButton =
          event.target.closest(
            '[data-edit-quantity]'
          );


        if (
          editQuantityButton
        ) {

          event.preventDefault();


          event.stopPropagation();


          openOnlyStep(
            'quantity'
          );


          return;

        }

        /* =====================================================
          WIJZIG GEEN PERSONALISATIE
          ===================================================== */

        const editNoPersonalisationButton =
          event.target.closest(
            '[data-edit-no-personalisation]'
          );


        if (
          editNoPersonalisationButton
        ) {

          event.preventDefault();


          event.stopPropagation();


          openOnlyStep(
            'option:' +
            editNoPersonalisationButton.dataset.editNoPersonalisation
          );


          return;

        }

        /* =====================================================
          WIJZIG SINGLE CHOICE
          ===================================================== */

        const editSingleChoiceButton =
          event.target.closest(
            '[data-edit-single-choice]'
          );


        if (
          editSingleChoiceButton
        ) {

          event.preventDefault();


          event.stopPropagation();


          openOnlyStep(
            'option:' +
            editSingleChoiceButton.dataset.editSingleChoice
          );


          return;

        }

        /* =====================================================
          WIJZIG VERDELINGSWAARDE
          ===================================================== */

        const editDistributionButton =
          event.target.closest(
            '[data-edit-distribution-value]'
          );


        if (
          editDistributionButton
        ) {

          event.preventDefault();


          event.stopPropagation();


          editDistributionValue(
            editDistributionButton.dataset.optionId,
            editDistributionButton.dataset.editDistributionValue
          );


          return;

        }

        /* =====================================================
          VERWIJDER VERDELINGSWAARDE
          ===================================================== */

        const removeDistributionButton =
          event.target.closest(
            '[data-remove-distribution-value]'
          );


        if (
          removeDistributionButton
        ) {

          event.preventDefault();


          event.stopPropagation();


          removeDistributionValue(
            removeDistributionButton.dataset.optionId,
            removeDistributionButton.dataset.removeDistributionValue
          );


          return;

        }

        /* =====================================================
          EXTRA VERDELINGSWAARDE
          ===================================================== */

        const addDistributionButton =
          event.target.closest(
            '[data-add-distribution-value]'
          );


        if (
          addDistributionButton
        ) {

          event.preventDefault();


          event.stopPropagation();


          addDistributionValue(
            addDistributionButton.dataset.optionId
          );


          return;

        }


        /* =====================================================
           TOEVOEGEN / OPSLAAN
           ===================================================== */

        const addToCartTrigger =
          event.target.closest(
            '[data-add-to-cart]'
          );


        if (
          addToCartTrigger
        ) {

          event.preventDefault();


          addToCart();


          return;

        }

        /* =====================================================
          AANTALVERDELING - WAARDE SELECTEREN
          ===================================================== */

        const distributionValue =
          event.target.closest(
            '[data-distribution-value]'
          );


        if (
          distributionValue
        ) {

          toggleDistributionValue(
            distributionValue.dataset.optionId,
            distributionValue.dataset.distributionValue
          );


          return;

        }

        /* =====================================================
          SINGLE CHOICE
          ===================================================== */

            const singleChoice =
              event.target.closest(
                '[data-single-choice]'
              );


            if (
              singleChoice
            ) {

              selectSingleChoice(
                singleChoice.dataset.optionId,
                singleChoice.dataset.singleChoice
              );


              return;

            }


        /* =====================================================
           PERSONALISATIEPOSITIE
           ===================================================== */

        const position =
          event.target.closest(
            '[data-position-id]'
          );


        if (
          position
        ) {

          selectPosition(
            position.dataset.optionId,
            position.dataset.positionId
          );


          return;

        }


        /* =====================================================
           GEEN PERSONALISATIE
           ===================================================== */

        const noPersonalisation =
          event.target.closest(
            '[data-no-personalisation]'
          );


        if (
          noPersonalisation
        ) {

          selectNoPersonalisation(
            noPersonalisation.dataset.optionId
          );


          return;

        }


        /* =====================================================
           TECHNIEK
           ===================================================== */

        const method =
          event.target.closest(
            '[data-method-id]'
          );


        if (
          method
        ) {

          selectMethod(
            method.dataset.optionId,
            method.dataset.methodId
          );


          return;

        }


        /* =====================================================
           VRIJ AANTAL - BEREKEN
           ===================================================== */

        const customQuantityTrigger =
          event.target.closest(
            '[data-custom-quantity-button]'
          );


        if (
          customQuantityTrigger
        ) {

          event.preventDefault();


          selectCustomQuantity();


          return;

        }


        /* =====================================================
           AANTAL UIT TABEL
           ===================================================== */

        const quantityRow =
          event.target.closest(
            '[data-quantity]'
          );


        if (
          quantityRow
        ) {

          selectQuantity(
            parseInt(
              quantityRow.dataset.quantity,
              10
            )
          );


          return;

        }

      }
    );

    /* =========================================================
      AANTALVERDELING - HANDMATIG AANPASSEN
      ========================================================= */

    root.addEventListener(
      'input',
      function(event) {

        const input =
          event.target.closest(
            '[data-distribution-input]'
          );


        if (!input) {
          return;
        }


        const optionId =
          input.dataset.optionId;


        const valueCode =
          input.dataset.distributionInput;


        const optionState =
          state.options[
            optionId
          ];


        if (!optionState) {
          return;
        }


        let value =
          parseInt(
            input.value,
            10
          );


        if (
          !Number.isFinite(value) ||
          value < 0
        ) {

          value = 0;

        }


        optionState.distribution[
          valueCode
        ] =
          value;


        optionState.manuallyAdjusted =
          true;

        optionState.distributionConfirmed =
          false;


        updateStepCompletion();

        /*
        * Alleen het totaal onderaan
        * opnieuw berekenen.
        *
        * We renderen hier bewust NIET
        * de hele configurator opnieuw,
        * anders verliest het invoerveld
        * tijdens het typen zijn focus.
        */

        const distributionBox =
          input.closest(
            '.ecobos-quantity-distribution'
          );


        if (!distributionBox) {
          return;
        }


        const totalRow =
          distributionBox.querySelector(
            '.ecobos-quantity-distribution__total'
          );


        if (!totalRow) {
          return;
        }


        const option =
          getOption(
            optionId
          );


        if (!option) {
          return;
        }


        const validation =
          getQuantityDistributionValidation(
            option
          );


        if (
          validation.valid
        ) {

          totalRow.textContent =
            'Totaal: ' +
            validation.total +
            ' stuks';


          totalRow.classList.remove(
            'has-error'
          );


          totalRow.classList.add(
            'is-valid'
          );

        }

        else {

          totalRow.classList.remove(
            'is-valid'
          );


          totalRow.classList.add(
            'has-error'
          );


          totalRow.textContent =
            'Totaal: ' +
            validation.total +
            ' stuks — minimum ' +
            validation.minimumQuantity +
            ' stuks';

        }

      }
    );


    /* =========================================================
       ENTER OP VRIJ AANTAL
       ========================================================= */

    if (
      customQuantityInput
    ) {

      customQuantityInput.addEventListener(
        'keydown',
        function(event) {

          if (
            event.key ===
            'Enter'
          ) {

            event.preventDefault();


            selectCustomQuantity();

          }

        }
      );

    }

        /* =========================================================
       START
       ========================================================= */

    const isEditing =
      restoreCartItemForEditing();


    renderOptionSteps();


    renderAllOptions();


    updateConfigurator();


    updateEditModeUI(
      isEditing
    );


    /*
     * Als we een bestaand winkelmand-item
     * bewerken, willen we niet automatisch
     * de eerste stap open laten staan als
     * de configuratie al volledig bestaat.
     *
     * Daarom openen we standaard de eerste
     * configuratiestap. Dat maakt wijzigen
     * voorspelbaar en eenvoudig.
     */

    if (
      isEditing &&
      config.options.length
    ) {

      openOnlyStep(
        'option:' +
        config.options[0].id
      );

    }

  }


  /* ===========================================================
     INIT
     =========================================================== */

  function initAllEcobosConfigurators() {

    document
      .querySelectorAll(
        '[data-ecobos-configurator]'
      )
      .forEach(
        function(root) {

          initEcobosConfigurator(
            root
          );

        }
      );

  }


  /*
   * Normale page load
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllEcobosConfigurators
    );

  }

  else {

    initAllEcobosConfigurators();

  }


  /*
   * Shopify Theme Editor:
   * een section kan dynamisch opnieuw
   * geladen worden zonder volledige
   * page refresh.
   */

  document.addEventListener(
    'shopify:section:load',
    function(event) {

      if (
        !event.target
      ) {
        return;
      }


      const root =
        event.target.matches &&
        event.target.matches(
          '[data-ecobos-configurator]'
        )
          ? event.target
          : event.target.querySelector(
              '[data-ecobos-configurator]'
            );


      if (
        root
      ) {

        initEcobosConfigurator(
          root
        );

      }

    }
  );

})();